import React from 'react';
import { UrlService } from "../../../../core/services/UrlService"
import './hero.scss';
import $ from "jquery";

const Hero: React.FC<any> = ({ bgImage = 'self-test/cholesterol/hero.png' }) => {
    const moveToSelfTest = () => {
        $("html, body").animate({ scrollTop: $('.self-test__test').position()?.top - 50 || 0 }, 1000);
    };

    const moveToContent = () => {
        $("html, body").animate({ scrollTop: $('.self-test__content-sections').position()?.top - 50 || 0 }, 1000);
    };

    return (
        <section role="img" aria-label="Image Description">
            <div className="self-test__hero" style={UrlService.getLocalImageUrlStyle(bgImage)}>
                <div className="container">
                    <div className="self-test__hero-title-container">
                        <div className="self-test__hero-title">
                            <h1 className="entry-title mb-4"> 您有膽固醇超標的風險嗎？</h1>
                        </div>
                    </div>

                    <div className="self-test__hero-content-container">
                        <div className="self-test__hero-content-text">
                            <p>
                            膽固醇超標是許多香港人的健康問題，除了會引致冠心病，更可造成腦中風<sup>1</sup>。
                            據估計，2017年，全球超過400萬人因膽固醇過高死亡<sup>2</sup>。
                            這個問題在香港更是常見，衞生署數據顯示，接近一半港人有膽固醇超標問題<sup>2</sup>，情況令人擔憂。
                            </p>
                            <p>
                                擔心自己膽固醇超標嗎？現時有不少降膽固醇藥，能減低您患上心血管疾病的風險<sup>3</sup>。
                                立即進行評估，了解您會否有膽固醇超標的風險！
                            </p>
                            <div className="self-test__hero-button-container">
                                <button className="self-test__button primary" onClick={moveToSelfTest}>
                                    開始評估
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;